import {v4 as uuidv4} from 'uuid';
import {App} from 'vue';

const TOAST_CONTAINER_ID: string = 'toasts';

interface ToastOptions {
    type?: string;
    timeout?: number;
}

interface Toast {
    id: string;

    success(message: string, options?: ToastOptions): HTMLElement;

    warning(message: string, options?: ToastOptions): HTMLElement;

    error(message: string, options?: ToastOptions): HTMLElement;

    create(message: string, options?: ToastOptions): HTMLElement;
}

const toast: Toast = {
    id: TOAST_CONTAINER_ID,

    success(message, options: ToastOptions = {}): HTMLElement {
        options.type = 'toasts-item-success';
        return this.create(message, options);
    },

    warning(message, options: ToastOptions = {}): HTMLElement {
        options.type = 'toasts-item-warning';
        return this.create(message, options);
    },

    error(message, options: ToastOptions = {}): HTMLElement {
        options.type = 'toasts-item-error';
        return this.create(message, options);
    },

    create(message, options: ToastOptions = {}): HTMLElement {

        const container = document.getElementById(this.id);

        if (!container) {
            throw new Error(`Toast container with id '${this.id}' not found.`);
        }

        const duration = options.timeout ?? 3000;
        const id: string = uuidv4()
        const toastElement: HTMLDivElement = document.createElement('div')
        const buttonCloseElement: HTMLButtonElement = document.createElement('button')

        let timerRemove: number;

        toastElement.setAttribute('id', id)
        toastElement.className = `toasts-item ${options.type || ''}`.trim();
        toastElement.innerText = message;

        buttonCloseElement.setAttribute('type', 'button');
        buttonCloseElement.className = 'toasts-item-close';
        buttonCloseElement.innerHTML = '<span class="icon-cancel"></span>';

        const remove = (): void => {
            const toastElement: null | HTMLElement = document.getElementById(id);
            if (toastElement) {
                toastElement.parentNode?.removeChild(toastElement);
            }
        };

        const removeHandler = (): void => {
            if (undefined !== timerRemove) {
                clearTimeout(timerRemove);
            }
            remove();
        };
        buttonCloseElement.addEventListener('click', removeHandler);

        toastElement.appendChild(buttonCloseElement);

        container.appendChild(toastElement);

        setTimeout(() => document.getElementById(id)?.setAttribute('data-control-active', 'true'), 100);

        timerRemove = setTimeout(remove, duration) as unknown as number;

        return toastElement;
    }
};

export default {
    install(app: App): void {
        let element = document.createElement('div');
        element.setAttribute('id', TOAST_CONTAINER_ID);
        element.className = 'toasts';

        document.body.appendChild(element);

        app.provide("$toast", toast);
        app.config.globalProperties.$toast = toast;
    }
};

export {toast, ToastOptions};
